import { motion } from "framer-motion";
import { MapPin, Clock, Zap, CheckCircle2 } from "lucide-react";

const shifts = [
  { venue: "Camden Electric Ballroom", area: "Camden", time: "Tonight · 21:00–03:00", rate: "£21/hr", tag: "URGENT", hot: true },
  { venue: "Thames Dock Arena", area: "Greenwich", time: "Sat · 17:00–23:30", rate: "£24/hr", tag: "EVENT", hot: false },
  { venue: "Canary Wharf One", area: "Canary Wharf", time: "Mon · 07:00–15:00", rate: "£19/hr", tag: "DAY SHIFT", hot: false },
];

export default function PhoneMockup() {
  return (
    <div className="relative mx-auto w-[300px] sm:w-[330px]" style={{ transformStyle: "preserve-3d" }}>
      <div className="glow-amber relative overflow-hidden rounded-[2.75rem] border border-white/10 bg-[#0b0f16] p-2.5 shadow-2xl">
        <div className="overflow-hidden rounded-[2.25rem] bg-[#07090e]">
          <div className="flex items-center justify-between px-5 pt-4 pb-2">
            <span className="font-mono-tag text-[9px] text-slate-500">21:47</span>
            <div className="h-5 w-24 rounded-full bg-black/80" />
            <div className="flex gap-1">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              <span className="h-1.5 w-1.5 rounded-full bg-slate-600" />
            </div>
          </div>

          <div className="px-5 pb-6 pt-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center overflow-hidden rounded">
                  <img src="/icons/icon-192.png" alt="GuardGig28 logo" className="h-full w-full object-cover" />
                </span>
                <span className="font-display text-sm font-bold uppercase text-slate-50">GuardGig28</span>
              </div>
              <span className="rounded-full border border-emerald-500/40 bg-emerald-500/10 px-2 py-0.5 font-mono-tag text-[8px] text-emerald-400">Verified</span>
            </div>

            <div className="mt-5 rounded-lg border border-amber-500/25 bg-amber-500/5 p-3">
              <p className="font-mono-tag text-[8px] text-amber-500">3 new shifts near you</p>
              <p className="mt-1 font-display text-2xl font-extrabold uppercase leading-none text-slate-50">£412<span className="text-sm text-slate-400"> this week</span></p>
            </div>

            <div className="mt-4 space-y-2.5">
              {shifts.map((s, i) => (
                <motion.div
                  key={s.venue}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 1.6 + i * 0.25, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                  className={`rounded-lg border p-3 ${s.hot ? "border-amber-500/50 bg-[#111520]" : "border-white/8 bg-[#0f141c]"}`}
                >
                  <div className="flex items-center justify-between">
                    <p className="font-display text-[13px] font-bold uppercase text-slate-100">{s.venue}</p>
                    <span className={`rounded px-1.5 py-0.5 font-mono-tag text-[7px] ${s.hot ? "bg-amber-500 text-[#07090e]" : "bg-white/10 text-slate-400"}`}>{s.tag}</span>
                  </div>
                  <div className="mt-1.5 flex items-center gap-3 text-[10px] text-slate-500">
                    <span className="flex items-center gap-1"><MapPin className="h-2.5 w-2.5" />{s.area}</span>
                    <span className="flex items-center gap-1"><Clock className="h-2.5 w-2.5" />{s.time}</span>
                  </div>
                  <div className="mt-2 flex items-center justify-between">
                    <span className="font-display text-base font-bold text-amber-500">{s.rate}</span>
                    <span className="rounded bg-amber-500/15 px-2 py-1 font-mono-tag text-[8px] text-amber-400">Tap to claim</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 2.4, duration: 0.6 }}
        className="animate-float-y absolute -right-16 top-16 hidden rounded-lg border border-emerald-500/30 bg-[#0f141c]/95 px-3 py-2 backdrop-blur sm:block"
      >
        <div className="flex items-center gap-2">
          <Zap className="h-3.5 w-3.5 text-emerald-400" />
          <span className="font-mono-tag text-[9px] text-emerald-400">Shift filled · 12 min</span>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 2.7, duration: 0.6 }}
        className="animate-float-y absolute -left-14 bottom-24 hidden rounded-lg border border-amber-500/30 bg-[#0f141c]/95 px-3 py-2 backdrop-blur sm:block"
        style={{ animationDelay: "1.4s" }}
      >
        <div className="flex items-center gap-2">
          <CheckCircle2 className="h-3.5 w-3.5 text-amber-500" />
          <span className="font-mono-tag text-[9px] text-amber-400">Shift completed · £186 earned</span>
        </div>
      </motion.div>
    </div>
  );
}
